
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["sofia_svg svg_icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"30 30 160 160"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"st3",attrs:{"cx":"111.12","cy":"44.68","r":"13.69"}}),_c('circle',{staticClass:"st3",attrs:{"cx":"111.12","cy":"177.56","r":"13.69"}}),_c('path',{staticClass:"st3",attrs:{"d":"M108.18 55.18h5.63v122.38h-5.63z"}})]),_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"st3",attrs:{"cx":"167.34","cy":"75.71","r":"13.69"}}),_c('circle',{staticClass:"st3",attrs:{"cx":"54.9","cy":"146.53","r":"13.69"}}),_c('path',{staticClass:"st3",attrs:{"d":"M156.892 78.813l3 4.764-103.545 65.228-3-4.763z"}})]),_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"st3",attrs:{"cx":"167.34","cy":"146.53","r":"13.69"}}),_c('circle',{staticClass:"st3",attrs:{"cx":"54.9","cy":"75.71","r":"13.69"}}),_c('path',{staticClass:"st3",attrs:{"d":"M53.331 78.2l3.001-4.763 103.546 65.229-3 4.763z"}})])])
          )
        }
      }
    